<div class="cads-card-view">
  @if (effectiveConfig().title) {
    <span class="cads-card-view__title">{{ effectiveConfig().title }}</span>
  }
  <div
    class="cads-card-view__surface"
    [class.cads-card-view__surface--colored]="effectiveConfig().color && !effectiveConfig().disabled"
    [class.cads-card-view__surface--neutral]="!effectiveConfig().color || effectiveConfig().disabled"
    [class.cads-card-view__surface--tappable]="isInteractive()"
    [class.cads-card-view__surface--disabled]="effectiveConfig().disabled"
    [ngStyle]="surfaceCssVars()"
    [attr.role]="isInteractive() ? 'button' : null"
    [attr.tabindex]="isInteractive() ? 0 : null"
    [attr.aria-disabled]="effectiveConfig().disabled ? true : null"
    (click)="_onActivate()"
    (keydown)="_onKeydown($event)"
    (keyup)="_onKeyup($event)"
  >
    <div class="cads-card-view__row">
      <div class="cads-card-view__content">
        <ng-content />
      </div>
      @if (showTrailingChevron()) {
        <span class="cads-card-view__trailing" aria-hidden="true">
          <cads-icon-view-bit [config]="trailingChevronBitConfig()" />
        </span>
      }
    </div>
  </div>
</div>
